import { Request, executeRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  console.log('kycDeleteDocument data:', data)
  return data
}

const kycDeleteDocument = (uploadId: string, documentId: string, uploadType: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.deleteKycDoc,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      uploadId: uploadId,
      documentId: documentId,
      uploadType: uploadType,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { kycDeleteDocument }
